module.exports = "/static/assets/04e2bd07d449e5c4901edef9fbec5113.png";